import React from "react"

import Table from "~tailwindui/Table/Table"

export type ExpenseTableProps = {
  title: string
  expenses: {
    description: string
    expenseType: string
    formattedAmount: string
    comments: string
    feedback: string
  }[]
  changePage: (page: number) => void
}

const ExpenseTable: React.FC<ExpenseTableProps> = ({
  title,
  expenses,
  changePage,
}) => {
  return (
    <Table
      title={title}
      data={expenses}
      changePage={changePage}
      cols={[
        { header: "Description", value: expense => expense.description },
        { header: "Type", value: expense => expense.expenseType },
        { header: "Amount", value: expense => expense.formattedAmount },
        { header: "Your Comments", value: expense => expense.comments },
        { header: "Admin Feedback", value: expense => expense.feedback },
      ]}
    />
  )
}

export default ExpenseTable
